import React from 'react';
import { PrimaryButtonPurple } from '../ui/Buttons';
import { useToast } from '../ui/Toast';
export function QRCodePanel() {
  const {
    addToast
  } = useToast();
  const handleAdd = () => {
    addToast('QR layer added...');
  };
  return <div className="h-full flex flex-col" data-id="element-234">
      <div className="p-4 border-b border-gray-100" data-id="element-235">
        <h2 className="font-semibold text-gray-900" data-id="element-236">QR code</h2>
      </div>

      <div className="p-4" data-id="element-237">
        <PrimaryButtonPurple className="w-full mb-6" onClick={handleAdd} data-id="element-238">
          Add new QR code
        </PrimaryButtonPurple>

        <p className="text-sm font-medium text-gray-900 mb-2" data-id="element-239">
          Add or select QR code
        </p>

        <div className="border-t border-gray-100" data-id="element-240">
          {/* Empty list placeholder */}
          <div className="py-4 border-b border-gray-100" data-id="element-241"></div>
          <div className="py-4 border-b border-gray-100" data-id="element-242"></div>
          <div className="py-4 border-b border-gray-100" data-id="element-243"></div>
        </div>
      </div>
    </div>;
}